import AddRoundedIcon from "@mui/icons-material/Add";

import Button, { ButtonTypes } from "../../Button";
import { CardStackIllustration } from "../CardStackIllustration";
import {
  Actions,
  CardStripe,
  Description,
  IllustrationBox,
  Title,
  Wrapper,
} from "./styles";
import { AccountEmptyStateProps } from "./types";
import { BREAKPOINTS } from "../../../utils/constants";
import { useResponsive } from "../../../hooks/useResponsive";

const DEFAULT_TITLE = "Add your first account";
const DEFAULT_DESCRIPTION =
  "Create an account to start tracking balances, transactions, and your overall financial health.";
const DEFAULT_BUTTON_LABEL = "Add account";
const DEFAULT_ARIA_LABEL = "No accounts yet";

const AccountEmptyState: React.FC<AccountEmptyStateProps> = ({
  onAddAccount,
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  buttonLabel = DEFAULT_BUTTON_LABEL,
  ariaLabel = DEFAULT_ARIA_LABEL,
  secondaryActionLabel,
  onSecondaryAction,
}) => {
  const isCompact = useResponsive(BREAKPOINTS.tabletMin);
  const secondaryAction =
    secondaryActionLabel && onSecondaryAction ? (
      <Button
        type={ButtonTypes.secondary}
        size="large"
        isFullWidth={isCompact}
        onClick={onSecondaryAction}
        aria-label={secondaryActionLabel}
      >
        {secondaryActionLabel}
      </Button>
    ) : null;

  return (
    <Wrapper role="region" aria-label={ariaLabel}>
      <IllustrationBox>
        <CardStackIllustration>
          <CardStripe />
          <AddRoundedIcon />
        </CardStackIllustration>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </IllustrationBox>

      <Actions>
        <Button
          type={ButtonTypes.primary}
          size="large"
          isFullWidth={isCompact}
          onClick={onAddAccount}
          aria-label={buttonLabel}
        >
          <AddRoundedIcon fontSize="small" />
          {buttonLabel}
        </Button>
        {secondaryAction}
      </Actions>
    </Wrapper>
  );
};

export default AccountEmptyState;
